/**
 * Adzuki. My Settings - My Shortcuts panel
 *
 * SET-55. THE LIST WRITES AS THE ADVISOR ACTS, so this file owns three interactions the Save
 * button has nothing to do with: dragging a tile to reorder, removing one, and adding one from
 * the search. Only the Maxx Hub Menu toggle belongs to the form.
 *
 * ITS HOOKS ARE NOT PRODUCTION'S, DELIBERATELY. The legacy settings screen binds .remove-item
 * and .shortcut-search-autocomplete, and AgentsSettingsForm.js binds the first FROM
 * document.body - which survives every panel render, so those handlers stack one per render
 * inside the modal. This panel's markup uses my-settings- prefixed hooks, so a click here never
 * reaches them and a click there never reaches this.
 *
 * DRAGULA IS ALREADY LOADED. It is concatenated into vendor.min.js and its css into
 * vendor.min.css, both of which the My Settings layout loads - the include_dragula layout flag
 * some controllers set has no reader anywhere in the app. Checked rather than assumed: the
 * built bundles contain the library and its gu- classes.
 *
 * RE-INITIALISED ON EVERY PANEL RENDER, because the panel arrives by AJAX and its elements are
 * replaced each time. The drag container is bound per element, so the previous instance is
 * destroyed rather than left holding a node that is no longer in the document.
 */

(function MySettingsShortcuts($, Adzuki)
{
	"use strict";

	var _drake = null,
	    // A MESSAGE WAITING FOR A RENDER. Add and remove re-read the whole panel, so the
	    // confirmation cannot be written before the reload - the element it goes in is about to
	    // be replaced. Held here and flushed when the new panel arrives.
	    _pending_flash = null,
	    _flash,
	    _fitDropdown,
	    _tileName,
	    _flashAfterRender,
	    _flushFlash,
	    _renumber,
	    _saveOrder,
	    _reload,
	    _notify,
	    _remove,
	    _add,
	    _initDrag,
	    _initSearch;

	/**
	 * Re-renders the whole panel from the server.
	 *
	 * THE PANEL, NOT THE GRID. The count, the empty state and the disabled search all follow
	 * from how many shortcuts are stored, so re-reading the panel keeps them in step with one
	 * request - and what the advisor sees is what was stored rather than this file's opinion of
	 * it. The same choice the Shipping list made.
	 */
	_reload = function reload()
	{
		if (Adzuki.MySettings && typeof Adzuki.MySettings.load === 'function') {
			Adzuki.MySettings.load('/MySettings/shortcuts', true);
		}
	};

	_notify = function notify(title, message)
	{
		if (typeof Adzuki.StatusMessage === 'function') {
			Adzuki.StatusMessage(title, message);
		}
	};

	/**
	 * Reports what just happened, beside the count chip.
	 *
	 * NOT Adzuki.StatusMessage, AND THE REASON IS CLICKS. StatusMessage is jconfirm's $.alert -
	 * a dialog the advisor has to dismiss - so managing shortcuts cost one extra click per add,
	 * per remove and per drag. Tidying a list of twenty is exactly the case where that adds up.
	 * Asked for by Phill on 10 Sep 2026.
	 *
	 * ERRORS STAY AS DIALOGS. The cap, the duplicate check and a refused delete each say
	 * something the advisor has to read before trying again, and a line of text beside a chip is
	 * missable. Only the confirmations move inline - they confirm what the panel already shows.
	 *
	 * @param string message What to report. Text, not markup.
	 *
	 * @return void
	 */
	/**
	 * The name a search result will wear once it is a tile.
	 *
	 * /Shortcuts/autocomplete labels every result "<hub> -> <item>", built in the controller so
	 * the advisor can tell two similarly named tools apart while searching. The tile itself
	 * carries only the item title, so the confirmation drops the prefix to match it.
	 *
	 * @param  string name Result label, which may carry a hub prefix.
	 *
	 * @return string
	 */
	_tileName = function tileName(name)
	{
		var parts = String(name || '').split('->');

		return $.trim(parts[parts.length - 1]) || 'Shortcut';
	};

	_flash = function flash(message)
	{
		$('.my-settings-overlay .my-settings-shortcut-flash').text(message);
	};

	/**
	 * Reports what just happened once the panel has been re-read.
	 *
	 * @param string message What to report after the next render.
	 *
	 * @return void
	 */
	_flashAfterRender = function flashAfterRender(message)
	{
		_pending_flash = message;
	};

	/**
	 * CONSUMED, NOT READ. Clearing it as it is spent is what stops the last add being reported
	 * again every time the advisor comes back to this panel.
	 *
	 * @return void
	 */
	_flushFlash = function flushFlash()
	{
		if (_pending_flash === null) {
			return;
		}

		_flash(_pending_flash);

		_pending_flash = null;
	};

	/**
	 * Rewrites the sequence numbers from each tile's current position.
	 *
	 * ITS OWN ELEMENT PER TILE, which is why this is three lines. The legacy sort screen
	 * renumbers by splitting each tile's innerHTML on the first "." and rebuilding it - which
	 * eats a full stop in a shortcut title, and is why sortShortcuts() strips full stops from
	 * titles before rendering them.
	 */
	_renumber = function renumber($grid)
	{
		$grid.find('.my-settings-shortcut').each(function number(index) {
			$(this).find('.my-settings-shortcut-seq').text(index + 1);
		});
	};

	/**
	 * Stores the order the tiles are now in.
	 *
	 * POSTED TO MySettings, NOT TO /Agents/processSortShortcuts. That endpoint is on
	 * EsourceAgentsController, so it exists only under Esource, and the modal resolves for every
	 * app - posting there would 404 wherever else it is hosted and read as "the order could not
	 * be saved".
	 *
	 * NO RE-RENDER ON SUCCESS. The numbers are already right, the tiles are already where the
	 * advisor put them, and reloading the panel under a hand that has just finished dragging is
	 * the one moment a re-render is worse than none.
	 */
	_saveOrder = function saveOrder($grid)
	{
		var order = [];

		$grid.find('.my-settings-shortcut').each(function collect() {
			order.push($(this).attr('data-my-settings-shortcut-id'));
		});

		$.ajax({
			url     : (Adzuki.base_uri || '') + '/MySettings/shortcutSort',
			type    : 'POST',
			data    : { sort: order.join(',') },
			dataType: 'json',
			success : function saved(response) {
				if (!response || response.status !== 'success') {
					_notify('Error', (response && response.data)
						? response.data
						: 'Your shortcut order could not be saved.');

					// THE ORDER ON SCREEN IS NOW A LIE, so the panel is re-read rather than left
					// showing an arrangement the server rejected.
					_reload();

					return;
				}

				_flash(response.data);
			},
			error: function failed() {
				_notify('Error', 'Your shortcut order could not be saved.');

				_reload();
			}
		});
	};

	/**
	 * Removes one shortcut, after asking.
	 *
	 * THE CONFIRMATION IS THE MODAL'S OWN DIALOG. removeBookmark() does not ask - unlike the
	 * shipping delete, which answers an unconfirmed request with the question - so the prompt is
	 * raised here. It is a removal the advisor can undo by searching for the link again, so the
	 * wording asks rather than warning.
	 */
	_remove = function remove(id, title)
	{
		var body = 'Remove ' + (title ? '"' + title + '"' : 'this shortcut') + ' from your shortcuts?';

		if (typeof Adzuki.CustomConfirm !== 'function') {
			return;
		}

		Adzuki.CustomConfirm({
			body   : body,
			confirm: function confirmed() {
				$.ajax({
					url     : (Adzuki.base_uri || '') + '/Shortcuts/removeBookmark',
					type    : 'POST',
					data    : { id: id },
					dataType: 'json',
					success : function removed(response) {
						// THESE ENDPOINTS ANSWER WITH success/message, not status/data - they
						// predate the modal and serve the CP Maxx home screen too, so the shape
						// is theirs rather than the settings convention.
						if (!response || !response.success) {
							_notify('Error', (response && response.message)
								? response.message
								: 'That shortcut could not be removed.');

							return;
						}

						// THE TITLE, NOT "Shortcut removed" - the advisor is working through a list and
						// the tile is already gone, so naming it is the only confirmation of WHICH one
						// went. Queued rather than written: the reload below replaces the element.
						_flashAfterRender(
							(title ? title : 'Shortcut') + ' removed from shortcuts'
						);

						_reload();
					},
					error: function failed() {
						_notify('Error', 'That shortcut could not be removed.');
					}
				});
			}
		});
	};

	/**
	 * Adds the menu link the advisor picked out of the search results.
	 */
	_add = function add(item, $input)
	{
		if (!item || item.id === null || item.id === undefined) {
			return;
		}

		$.ajax({
			url     : (Adzuki.base_uri || '') + '/Shortcuts/saveBookmark',
			type    : 'POST',
			data    : { id: item.id },
			dataType: 'json',
			success : function added(response) {
				$input.removeClass('ajax-spinner');
				$input.val('');

				if (!response || !response.success) {
					// the ceiling and the duplicate check both answer here, and both say
					// something the advisor needs to read - so the server's message is shown
					// rather than a generic failure
					_notify('Error', (response && response.message)
						? response.message
						: 'That shortcut could not be added.');

					return;
				}

				// THE TILE'S NAME, NOT THE SEARCH RESULT'S. A result reads "Bookings -> Cruise
				// Search" and the tile it becomes reads "Cruise Search", so the hub prefix is
				// dropped - the advisor is about to look for the tile, and it should be called what
				// the message called it.
				_flashAfterRender(_tileName(item.name) + ' added to shortcuts');

				// the count, the numbering and the search's own disabled state all come from the
				// server, so the panel is re-read rather than patched
				_reload();
			},
			error: function failed() {
				$input.removeClass('ajax-spinner');

				_notify('Error', 'That shortcut could not be added.');
			}
		});
	};

	/**
	 * Makes the grid draggable.
	 */
	_initDrag = function initDrag()
	{
		var $grid = $('.my-settings-overlay #my-settings-shortcut-grid');

		// the previous panel's container is gone from the document; releasing it here is what
		// stops one drake per render accumulating against detached nodes
		if (_drake) {
			_drake.destroy();

			_drake = null;
		}

		if (!$grid.length) {
			return;
		}

		// SAYS SO RATHER THAN FAILING QUIETLY. Without this a missing library is indisting-
		// uishable from a drag that starts and will not drop, which cost a round trip once.
		if (typeof window.dragula !== 'function') {
			if (window.console && console.warn) {
				console.warn('My Settings: dragula is not loaded, so shortcuts cannot be reordered.');
			}

			return;
		}

		_drake = window.dragula([$grid[0]], {
			// THE GRIP IS THE HANDLE, and only the grip.
			//
			// This started as an `invalid` that excluded the remove button and the name link and
			// let the rest of the tile drag. That is worse in both directions: the name is the
			// obvious thing to grab and it was the one place that did nothing, while the tile
			// dragged from places with no affordance saying so. A handle check makes the grip's
			// `cursor: grab` a promise the behaviour keeps. It is also what this codebase
			// already does - ts_agent_schedule.js drags its days by a handle class.
			moves: function moves(el, source, handle) {
				return Boolean($(handle).closest('.my-settings-shortcut-grip').length);
			},
			revertOnSpill  : true,
			// THE MIRROR GOES IN THE OVERLAY, not at body level where dragula puts it by
			// default. Same reason ts_agent_schedule.js names its own container: the clone that
			// follows the pointer is a separate element, and leaving it outside the overlay puts
			// it in a different stacking context from the panel it was lifted out of.
			mirrorContainer: $grid.closest('.my-settings-overlay')[0] || document.body
		});

		// A TOOLTIP CANNOT DISMISS ITSELF DURING A DRAG. The press keeps the pointer inside the
		// element, so no mouseleave arrives - and dragula builds the mirror by CLONING the tile,
		// which copies any tooltip Bootstrap has injected as a sibling of its trigger. So the
		// bubble is dismissed before the clone is taken, and anything left behind is swept after.
		//
		// BELT AND BRACES ON TOP OF THE GRIP HAVING NO TOOLTIP: the remove button in the tile
		// being dragged has one, and this is the seam where either would strand a bubble.
		_drake.on('drag', function dragStarted() {
			$grid.find('[data-toggle="tooltip"]').tooltip('hide');
		});

		_drake.on('dragend', function dragEnded() {
			// a cloned bubble belongs to no Bootstrap instance, so removing the element IS the
			// cleanup - there is no instance state left to reset
			$grid.find('.tooltip').remove();
		});

		_drake.on('drop', function dropped() {
			// LIVE, BEFORE THE REQUEST. The ticket asks for the numbers to follow the drag; they
			// describe position, which is already true on drop, so they do not wait on the save.
			_renumber($grid);

			_saveOrder($grid);
		});
	};

	/**
	 * Wires the Add Shortcuts search.
	 *
	 * SAFE TO CALL PER RENDER: Adzuki.Typeahead binds to the element it is given and guards
	 * against instantiating twice on the same one, and the input is a new element after each
	 * render.
	 */
	/**
	 * Keeps the results dropdown inside the panel that is clipping it.
	 *
	 * SET-55 QA: .my-settings-body carries `overflow: auto`, so a dropdown opening past the
	 * bottom of the panel is CUT OFF rather than scrolled to. The menu's own `max-height: 400px`
	 * never engaged, because at 400px it was not overflowing ITSELF - it was overflowing its
	 * container. Searching "reserva" showed about five and a half rows and the rest were
	 * unreachable: the dropdown would not scroll and neither would the panel, so the only way on
	 * was to type more and narrow the list.
	 *
	 * MEASURED AND CAPPED RATHER THAN RE-PARENTED. The same trap is written up at
	 * _my_settings.scss:2354 for the schedule time pickers, and the conclusion there was that
	 * moving a widget onto <body> breaks its positioning. So the menu stays where it is and is
	 * told how much room it actually has; its own overflow then does the scrolling.
	 *
	 * @param {jQuery} $input The search field the menu belongs to.
	 *
	 * @return {void}
	 */
	_fitDropdown = function fitDropdown($input)
	{
		// the plugin inserts the menu as the input's sibling
		var $menu = $input.siblings('ul.typeahead').first(),
		    $body = $input.closest('.my-settings-body'),
		    room;

		if (!$menu.length || !$body.length || !$menu.is(':visible')) {
			return;
		}

		// from the top of the menu to the bottom of the box that clips it, less a little air
		room = $body[0].getBoundingClientRect().bottom - $menu[0].getBoundingClientRect().top - 12;

		// a floor, so a search typed with the field near the bottom still shows something usable
		// rather than a sliver
		if (room < 120) {
			room = 120;
		}

		// and never taller than the stylesheet's own ceiling
		if (room > 400) {
			room = 400;
		}

		$menu.css('max-height', room + 'px');
	};

	_initSearch = function initSearch()
	{
		var $input = $('.my-settings-overlay #my-settings-shortcut-search');

		if (!$input.length || $input.prop('disabled') || typeof Adzuki.Typeahead !== 'function') {
			return;
		}

		Adzuki.Typeahead(
			$input,
			function source(term, display, $self) {
				Adzuki.Ajax.get('/Shortcuts/autocomplete/' + encodeURIComponent(term))
					.then(function results(response) {
						display(response);

						// after the plugin has painted them, so the menu has a height to measure
						window.setTimeout(function sized() {
							_fitDropdown($self);
						}, 0);
					})
					.catch(function failed() {
						$self.removeClass('ajax-spinner');

						display([{ name: 'There was an error searching for menu links.' }]);
					});
			},
			function select(item, $self) {
				_add(item, $self);
			},
			function template(item) {
				// THE HIGHLIGHTER PARSES THIS AS JSON to draw the hub colour square beside the
				// name. Under the link menu the endpoint returns no icon at all, and passing the
				// object anyway rendered `class="undefined" style="undefined"` - so a plain
				// string is handed over instead, which the highlighter treats as text.
				return item.icon ? JSON.stringify(item) : item.name;
			}
		);
	};

	$(document).ready(function documentReady() {
		// DELEGATED FROM document AND BOUND ONCE, so a re-render cannot double it. The panel is
		// replaced on every render, so there is nothing to bind to at ready.
		$(document).on('click', '.my-settings-overlay [data-my-settings-shortcut-remove]', function remove(e) {
			var $button = $(this);

			e.preventDefault();

			_remove(
				$button.attr('data-my-settings-shortcut-remove'),
				$.trim($button.closest('.my-settings-shortcut').find('.my-settings-shortcut-name').text())
			);
		});

		// SET-8's seam: a panel has arrived and its elements are new ones.
		$(document).on('my-settings:rendered', function panelRendered() {
			_initDrag();

			_initSearch();

			// AFTER the panel exists, because the element the message goes in arrived with it
			_flushFlash();
		});
	});
}(jQuery, window.Adzuki || {}));
